module.exports = __webpack_public_path__ + "img/le.d232abb5.png";